import { Box, DashboardModule } from '@domain-group/suit-theme'

import type { TaskListModel } from '@domain-group/realhub-backend-api-types'

import useTrackingLinks from '@hooks/useTrackingLinks'

import TrackingLink from './TrackingLink'

interface LinksProps {
  taskList: TaskListModel,
}

const Links = (props: LinksProps) => {
  const { taskList } = props

  const taskTrackingLinksPayload = useTrackingLinks({
    filters: {
      recipient_type: 'TaskListTemplate',
      recipient_id: taskList.task_list_template_id,
    },
    performHttpRequests: !!taskList.task_list_template_id,
  })

  const { filteredTrackingLinks, hasFilteredTrackingLinks } = taskTrackingLinksPayload

  if (!hasFilteredTrackingLinks){
    return null
  }

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Links"
    >
      <Box flexDirection="column">
        {filteredTrackingLinks.map(trackingLink => (
          <TrackingLink key={trackingLink.id} trackingLink={trackingLink} />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default Links
